module.exports = __webpack_public_path__ + "static/media/headerImage.20cd9d87.svg";